var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-item',{on:{"mouseenter":_vm.mouseEnter,"mouseleave":_vm.mouseLeave}},[_c('v-list-item-title',{staticClass:"pr-4"},[_vm._v(" "+_vm._s(_vm.item.name)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }